import React from 'react';
import {
  Flex, Heading, Text, Icon, Box, Badge,
  SimpleGrid, Table, Thead, Tbody, Tr, Th, Td,
  useColorModeValue,
} from '@chakra-ui/react';
import { MdBusinessCenter, MdWater, MdAssignment, MdCheckCircle, MdSchedule } from 'react-icons/md';
import Card from 'components/card/Card.js';

const MOCK_SOLICITACOES = [
  { protocolo: 'OS-2026-0041', tipo: 'Troca de Hidrômetro', local: 'R. das Flores, 123',  status: 'em_execucao', data: '16/03/2026' },
  { protocolo: 'OS-2026-0035', tipo: 'Ligação Nova',         local: 'Av. Brasil, 890',      status: 'concluida',   data: '14/03/2026' },
  { protocolo: 'OS-2026-0029', tipo: 'Drenagem de Rede',     local: 'R. do Comércio, 45',   status: 'concluida',   data: '10/03/2026' },
];

const STATUS_COLORS = { em_execucao: 'orange', concluida: 'green', aberta: 'blue', pendente: 'yellow' };
const STATUS_LABELS = { em_execucao: 'Em Execução', concluida: 'Concluída', aberta: 'Aberta', pendente: 'Pendente' };

/**
 * Acompanhamento — Perfil Cliente / Fiscalizador SABESP
 * Permite ao cliente acompanhar o status das solicitações de serviço.
 */
export default function Acompanhamento() {
  const textColor   = useColorModeValue('navy.700', 'white');
  const subText     = useColorModeValue('gray.500', 'gray.400');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  const emExecucao = MOCK_SOLICITACOES.filter((s) => s.status === 'em_execucao').length;
  const concluidas = MOCK_SOLICITACOES.filter((s) => s.status === 'concluida').length;

  return (
    <Flex direction="column" pt={{ base: '8px', md: '16px', xl: '0px' }}>
      {/* Header */}
      <Card p="5" mb="6">
        <Flex align="center" gap="3">
          <Icon as={MdWater} boxSize="30px" color="brand.500" />
          <Box>
            <Heading size="md" color={textColor}>Acompanhamento de Serviços</Heading>
            <Text fontSize="sm" color={subText}>
              Acompanhe em tempo real o status das ordens de serviço solicitadas à PG Soluções
            </Text>
          </Box>
        </Flex>
      </Card>

      {/* Stats */}
      <SimpleGrid columns={{ base: 1, md: 3 }} gap="20px" mb="6">
        {[
          { label: 'Total de OS',   value: MOCK_SOLICITACOES.length, icon: MdAssignment, color: 'blue.400'   },
          { label: 'Em Execução',   value: emExecucao,               icon: MdSchedule,   color: 'orange.400' },
          { label: 'Concluídas',    value: concluidas,               icon: MdCheckCircle,color: 'green.400'  },
        ].map(({ label, value, icon, color }) => (
          <Card key={label} p="5">
            <Flex align="center" gap="3">
              <Icon as={icon} boxSize="26px" color={color} />
              <Box>
                <Text fontSize="2xl" fontWeight="bold" color={textColor}>{value}</Text>
                <Text fontSize="sm" color={subText}>{label}</Text>
              </Box>
            </Flex>
          </Card>
        ))}
      </SimpleGrid>

      {/* Listagem de solicitações */}
      <Card p="6">
        <Flex align="center" gap="3" mb="4">
          <Icon as={MdBusinessCenter} boxSize="22px" color="brand.500" />
          <Heading size="sm" color={textColor}>Minhas Solicitações</Heading>
        </Flex>
        <Box overflowX="auto">
          <Table variant="simple" size="sm">
            <Thead>
              <Tr>
                <Th borderColor={borderColor}>Protocolo</Th>
                <Th borderColor={borderColor}>Tipo de Serviço</Th>
                <Th borderColor={borderColor}>Local</Th>
                <Th borderColor={borderColor}>Data</Th>
                <Th borderColor={borderColor}>Status</Th>
              </Tr>
            </Thead>
            <Tbody>
              {MOCK_SOLICITACOES.map((s) => (
                <Tr key={s.protocolo}>
                  <Td borderColor={borderColor} fontFamily="mono" fontSize="xs">{s.protocolo}</Td>
                  <Td borderColor={borderColor}>{s.tipo}</Td>
                  <Td borderColor={borderColor}>{s.local}</Td>
                  <Td borderColor={borderColor} fontSize="xs">{s.data}</Td>
                  <Td borderColor={borderColor}>
                    <Badge colorScheme={STATUS_COLORS[s.status] || 'gray'} borderRadius="full" px="2">
                      {STATUS_LABELS[s.status] || s.status}
                    </Badge>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
        <Text fontSize="xs" color={subText} mt="3">* Dados de exemplo — integração em desenvolvimento</Text>
      </Card>
    </Flex>
  );
}
